export default __webpack_public_path__ + "static/media/7.e1a02611.jpeg";